import api from './axios';

/**
 * Busca todos os dados consolidados do dashboard
 * @param {string} userId - ID do usuário
 * @returns {Promise} - Dados do dashboard (current + monthly)
 */
export function getDashboardData(userId) {
  return api.get(`/dashboard/${userId}`).then(r => r.data);
}
